import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { User } from 'src/app/shared/services/auth.service';
import { IState } from 'src/app/shared/store/root.reducer';
import { smoothlyMenu } from 'src/app/app.helpers';
import { DealerService } from 'src/app/shared/services/dealer.service';
import { OpsFeatures } from 'src/app/ops-features';
import { LocalStorageService } from 'angular-2-local-storage';

import { Init } from '../../features/new-claim-wizard/store/actions/new-claim-wizard.actions';
import * as newClaimActions from '../../features/new-claim-wizard/store/actions/new-claim-wizard.actions';

declare var jQuery: any;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, AfterViewInit, OnDestroy {
  condition1 = 'TRX_SND_ORDR';
  navigationMenuCssClass: string;
  isManIdAvailable: boolean;
  isThirdPartyEnabled: boolean;
  isManualManEnabled: boolean;
  isPartSearchEnabled: boolean;
  subscriptions: Subscription[] = [];
  searchCriteria: string;
  currentUser: User = <User>{};

  PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  };

  showSmartSearchSlider = 'false';
  constructor(
    private dealerService: DealerService,
    private router: Router,
    private store: Store<IState>,
    public toastr: ToastrService,
    public opsFeature: OpsFeatures,
    private localStorage: LocalStorageService
  ) { }

  ngOnDestroy() {
    this.subscriptions.map(subscription => {
      subscription.unsubscribe();
    });
  }

  ngOnInit() {
    this.searchCriteria = '';
    this.showSmartSearchSlider = 'false';
    this.isManIdAvailable = false;
    this.subscriptions.push(this.store.pipe(select(state => state.fullScreen))
      .subscribe(fullScreenState => {
        this.navigationMenuCssClass = fullScreenState.navigationMenuCssClass;
      }));
    this.subscriptions.push(this.store.pipe(select(state => state.currentUser))
      .subscribe(currentUser => {
        this.currentUser = currentUser;
      }));
    this.subscriptions.push(this.store.pipe(select(state => state.appParams.manufacturers)).subscribe(manufacturers => {
      if (manufacturers && manufacturers.length > 0) {
        this.isManIdAvailable = manufacturers.length > 0;
        this.isThirdPartyEnabled = manufacturers.filter(man => man.thirdPartyClaimEnabled === true).length > 0;
        this.isManualManEnabled = manufacturers.filter(man => man.manualClaimEnabled === true).length > 0;
        this.isPartSearchEnabled = manufacturers.filter(man => man.partSearchEnabled === true).length > 0;
      }
    }));
  }

  goToSmartSearch() {
    this.showSmartSearchSlider = 'true';
  }

  onCloseSearch(event: string) {
    this.showSmartSearchSlider = 'false';
  }

  toggleNavigation(): void {
    jQuery('body').toggleClass('mini-navbar');
    smoothlyMenu();
  }

  ngAfterViewInit() {
    jQuery('#side-menu').metisMenu();
    jQuery('#side-menu-scroll').metisMenu();
  }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }
  onNewClaimQuoteNavigation() {
    this.localStorage.remove(newClaimActions.NEW_CLAIM_WIZARD_VALUES);
    this.store.dispatch(new Init(null));
  }
}
